import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectCordLength = ({ id = "select-cord-length", ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const label = intl.formatMessage
          ? intl.formatMessage({ id: "cordLength", defaultMessage: "Cord Length" })
          : "Cord Length";

     const optionNames = [
          "<15 ft",
          "<20 ft",
          "<25 ft",
          "<30 ft",
          intl.formatMessage({ id: "all", defaultMessage: "All" }),
     ];

     const optionValues = ["15", "20", "25", "30", "all"];

     return (
          <Select
               id={id}
               value={userPrefs.get("chargerCordLength")?.toString() ?? "all"}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={(e) => {
                    const val = e.target.value === "all" ? null : Number(e.target.value);
                    userPrefs.set({ chargerCordLength: val });
               }}
               {...rest}
          />
     );
};

export default SelectCordLength;

SelectCordLength.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
